import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Optional,
  ViewChild,
} from '@angular/core';
import { BoobleModalService } from 'booble-modal';
import { NotifierService } from 'angular-notifier';

import { AuthenticationService } from 'src/app/shared/services';
import { CorporateAccountService } from 'src/app/shared/services/corporate-account.service';
import { TaxService } from 'src/app/shared/services/tax.service';
import { BrokerHubService } from 'src/app/shared/services/broker-hub.service';
import { LINK_REFINITV } from 'src/environments/environment';
import { QuotationModalComponent } from '../quotation-modal.component';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { TenantGeneralService } from 'src/app/core/tenant-general.service';
import { MerchantService } from 'src/app/core/merchant.service';

@Component({
  selector: 'app-quotation-modal-mobile',
  templateUrl: './quotation-modal-mobile.component.html',
  styleUrls: ['../quotation-modal.component.scss'],
})
export class QuotationModalMobileComponent
  extends QuotationModalComponent
  implements OnInit, OnDestroy
{
  constructor(
    taxService: TaxService,
    authService: AuthenticationService,
    companyService: CorporateAccountService,
    orderService: OrdersService,
    modalService: BoobleModalService,
    notifierService: NotifierService,
    tenantService: TenantGeneralService,
    merchantService: MerchantService,

    brokerHub: BrokerHubService,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) private dataBottomSheet,
    @Optional()
    private bottomSheetRef: MatBottomSheetRef<QuotationModalMobileComponent>
  ) {
    super(
      authService,
      orderService,
      companyService,
      modalService,
      brokerHub,
      notifierService,
      tenantService,
      merchantService
    );
  }

  ngOnInit() {
    if (this.isMobile) {
      this.boobleModalData = this.dataBottomSheet;
    }

    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  closeBottomSheet() {
    this.bottomSheetRef.dismiss();
  }
  confirmQuotation() {
    super.confirm();
    this.closeBottomSheet();
  }
}
